function record(message: string) {
    return `[QLife Header Bidding] ${message}`
}

/* tslint:disable:no-any */
export default class Logger {
    public static debug(message: string, ...args: any[]) {
        console.debug(record(message), ...args)
    }
    public static info(message: string, ...args: any[]) {
        console.info(record(message), ...args)
    }
    public static warn(message: string, ...args: any[]) {
        console.warn(record(message), ...args)
    }
    public static error(message: string, ...args: any[]) {
        console.error(record(message), ...args)
    }
    public static time(message: string) {
        console.time(record(message))
    }
    public static timeEnd(message: string) {
        console.timeEnd(record(message))
    }
}
/* tslint:enable:no-any */
